import { useRouter } from "vue-router";
export function saveToken(data: any) {
  const now = new Date();
  data.push(now.getTime() + 10800000);
  const dataAsJson = JSON.stringify(data);
  localStorage.setItem("token", dataAsJson);
}
export function removeToken() {
  localStorage.removeItem("token");
  localStorage.removeItem("accessToken");
}
function checkStorage() {
  if (typeof localStorage !== "undefined") {
    return true;
  } else {
    return false;
  }
}
export function getToken() {
  localStorage.getItem("token");
}
export function saveUsername(data: any) {
  //const dataAsJson = JSON.stringify(data);
  localStorage.setItem("username", data[0]);
}
export function removeUsername() {
  localStorage.removeItem("username");
}
export function getUsername() {
  localStorage.getItem("username");
}
export function saveSchemaId(data: any) {
  localStorage.setItem("schemaId", data);
}
export function removeSchemaId() {
  localStorage.removeItem("schemaId");
}
export function getSchemaid() {
  localStorage.getItem("schemaId");
}
export function saveLanguageId(data: any) {
  localStorage.setItem("languageId", data[0]);
}
export function removeLanguageId() {
  localStorage.removeItem("languageId");
}
export function getLanguageId() {
  localStorage.getItem("languageId");
}
export function saveRegion(data: any) {
  localStorage.setItem("regionData", data);
}
export function removeRegion() {
  localStorage.removeItem("regionData");
}
export function getRegion() {
  localStorage.getItem("regionData");
}
export function saveUserId(data: any) {
  //const dataAsJson = JSON.stringify(data);
  localStorage.setItem("userId", data);
}
export function removeUserId() {
  localStorage.removeItem("userId");
}
export function getUserId() {
  return localStorage.getItem("userId");
}
export function saveRoutes(data: any) {
  const dataAsJson = JSON.stringify(data);
  localStorage.setItem("routes", dataAsJson);
}
export function removeRoutes() {
  localStorage.removeItem("routes");
}
export function getRoutes() {
  localStorage.getItem("routes");
}
export function saveChosen(data: any) {
  localStorage.setItem("categories", data);
}

export function deleteChosen() {
  localStorage.removeItem("categories");
}

export function getChosen() {
  return localStorage.getItem("categories");
}
export function removeMenuId() {
  localStorage.removeItem("menuId");
}
export function setUserInfo(data: any) {
  localStorage.setItem("userInfo", data);
}

const STORAGE_CONFIGURATION = "CONFIGURATION";
const STORAGE_CONTACT = "CONTACT";
const STORAGE_PARAMETERS = "PARAMETERS";
const STORAGE_RESOURCE = "RESOURCE_ID";

export const storage = {
  addConfiguration(data: any) {
    this.clearConfiguration();

    const now = new Date();

    data.append("expiry", now.getTime() + 10800000);

    this._set(STORAGE_CONFIGURATION, data);
  },
  addContact(data: any) {
    this._set(STORAGE_CONTACT, data);
  },
  addParameters(data: any) {
    this.clearParameters();

    const now = new Date();

    data.append("expiry", now.getTime() + 10800000);

    this._set(STORAGE_PARAMETERS, data);
  },
  addResource(data: any) {
    this.clearResource();
    const now = new Date();

    data.push(now.getTime() + 10800000);
    this._set(STORAGE_RESOURCE, data);
  },
  getConfiguration(): object[] {
    const config = this._get(STORAGE_CONFIGURATION);
    if (config[0] != undefined) {
      const now = new Date();
      if (now.getTime() > config[0].expiry) {
        this.clearConfiguration();
        useRouter().push({ name: "Onboarding" });

        return [];
      } else {
        return config;
      }
    } else {
      return config;
    }
  },
  getContact(): object[] {
    return this._get(STORAGE_CONTACT);
  },
  getParameters(): object[] {
    const params = this._get(STORAGE_PARAMETERS);

    if (params[0] != undefined) {
      const now = new Date();

      if (now.getTime() > params[0].expiry) {
        this.clearParameters();
        useRouter().push({ name: "Onboarding" });

        return [];
      } else {
        return params;
      }
    } else {
      return params;
    }
  },
  getResource(): object[] {
    const resource = this._get(STORAGE_RESOURCE);

    if (resource[0] != undefined) {
      const now = new Date();

      if (now.getTime() > resource[0][1]) {
        this.clearResource();
        useRouter().push({ name: "Onboarding" });

        return [];
      } else {
        return resource[0][0];
      }
    } else {
      return resource[0];
    }
  },
  clearConfiguration() {
    this._clear(STORAGE_CONFIGURATION);
  },
  clearContact() {
    this._clear(STORAGE_CONTACT);
  },
  clearParameters() {
    this._clear(STORAGE_PARAMETERS);
  },
  clearResource() {
    this._clear(STORAGE_RESOURCE);
  },
  _set(key: string, data: any) {
    const uploadedData = this._get(key);

    const toObject = {} as any;
    data.forEach((value: any, key: any) => (toObject[key] = value));

    uploadedData.push(toObject);

    const dataAsJson = JSON.stringify(uploadedData);

    localStorage.setItem(key, dataAsJson);
  },
  _get(key: string) {
    const dataAsJson = localStorage.getItem(key) || "[]";

    return JSON.parse(dataAsJson);
  },
  _clear(key: string) {
    if (checkStorage()) {
      localStorage.removeItem(key);
    } else {
      return;
    }
  },
};
